import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IBetting } from './model';
import { IDrawUserBets } from '@libs/interfaces';

const selectBettingFeat = createFeatureSelector<Readonly<IBetting>>('betting');

export const selectBetting = createSelector(selectBettingFeat, (betting: IBetting) => betting);
export const selectBet = createSelector(selectBettingFeat, (betting: IBetting) => betting?.bet);
export const selectBetBt = createSelector(selectBettingFeat, (betting: IBetting) => betting?.bet?.betType);
export const selectDub = createSelector(selectBettingFeat, (betting: IBetting) => betting?.dub);
export const selectDraw = createSelector(selectBettingFeat, (betting: IBetting) => betting?.draw);
export const selectDubFinished = createSelector(
  selectBettingFeat,
  (betting: IBetting): IDrawUserBets => betting.dubFinished,
);
export const selectDubDraw = createSelector(selectBettingFeat, (betting: IBetting) => betting?.dub?.draw);
export const selectDubFinishedDraw = createSelector(
  selectBettingFeat,
  (betting: IBetting) => betting.dubFinished?.draw,
);
export const selectDubEvaluated = createSelector(selectBettingFeat, (betting: IBetting) => betting?.dub?.evaluated);
export const selectDubBets = createSelector(selectBettingFeat, (betting: IBetting) => betting?.dub?.bets);
export const selectDubFinishedBets = createSelector(
  selectBettingFeat,
  (betting: IBetting) => betting.dubFinished?.bets,
);
export const selectDrawsTable = createSelector(selectBettingFeat, (betting: IBetting) => betting?.drawsTable);
export const selectSchedule = createSelector(selectBettingFeat, (betting: IBetting) => betting?.schedule);
export const selectLastBetting = createSelector(selectBettingFeat, (betting: IBetting) => betting?.betting);
export const selectPendingBets = createSelector(selectBettingFeat, (betting: IBetting) => betting?.pending);
export const selectNextDraws = createSelector(selectBettingFeat, (betting: IBetting) => betting?.nextDraws);
export const selectEthBlocks = createSelector(selectBettingFeat, (betting: IBetting) => betting?.eth_blocks);
